import { useQuery } from '@tanstack/react-query';

import { fetchClaimDetails } from '../data-provider/claim-details';

export const useGetClaimDetails = (claimKey: number | undefined) => {
  return useQuery({
    enabled: Boolean(claimKey),
    queryFn: () => {
      return fetchClaimDetails({ ClaimKey: Number(claimKey) });
    },
    queryKey: ['claims-loss-and-damage-details', claimKey],
  });
};
